import * as React from 'react';
import { observer } from 'mobx-react';
import { assertNever } from '@kofno/piper';
import { Maybe } from 'maybeasy';
import DashboardSummaryStore from '../../DashboardSummaryStore';
import { Link } from '../../Resource/Types';
import IdleState from './IdleState';
import LoadingState from './LoadingState';
import SuccessState from './SuccessState';
import FailedState from './FailedState';
import EmptyState from './EmptyState';

interface Props {
  store: DashboardSummaryStore;
  onRefresh?: () => void;
  fullReportLink: Maybe<Link>;
  onDateRangeChange?: (startDate: string, endDate: string) => void;
}

const DashboardSummary: React.FC<Props> = ({
  store,
  onRefresh,
  fullReportLink,
  onDateRangeChange,
}) => {
  const state = store.state;

  switch (state.kind) {
    case 'idle':
      return <IdleState onRefresh={onRefresh} />;

    case 'loading':
      return <LoadingState />;

    case 'success':
      return (
        <SuccessState
          summary={state.summary}
          onRefresh={onRefresh}
          fullReportLink={fullReportLink}
          onDateRangeChange={onDateRangeChange}
        />
      );

    case 'failed':
      return <FailedState error={state.error} onRefresh={onRefresh} />;

    case 'empty':
      return (
        <EmptyState
          message={state.message}
          filters={state.filters}
          hadPreviousSuccess={state.hadPreviousSuccess}
          onDateRangeChange={onDateRangeChange}
        />
      );

    default:
      return assertNever(state);
  }
};

export default observer(DashboardSummary);
